import useSWR from 'swr/immutable';

import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';

import type { UspData } from '../modules/Usp/types';
import { getUspFetchParams } from '../utils/getUspFetchParams';
import { bucketFetcher } from '../utils/fetcher';

/**
 * Fetches and transforms USP data using the SWR (Stale-While-Revalidate) strategy.
 *
 * @returns The transformed USP data, or undefined if the data is not yet available.
 */
export const useUspData = () => {
  const { locale } = useI18n();
  const { endpoint, cacheKey } = getUspFetchParams(locale);
  const { data } = useSWR<UspData>(cacheKey, () => bucketFetcher<UspData>(endpoint, 240)());

  return data;
};
